export const stripOutChromaVersion = name =>
  name.toLowerCase().includes('chroma')
    ? name.toLowerCase().includes('legacy')
      ? name
      : 'Chroma'
    : name;
